import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from 'store'
import { Provider } from 'react-redux'
import 'lang/Lang';
import { SWRConfig } from 'swr';
import { swrGlobalConfig } from 'utils/constants';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <SWRConfig value={swrGlobalConfig}>
      <App />
    </SWRConfig>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
